module.exports = __webpack_public_path__ + "static/media/matching-score-end-season.bbbb6c67.png";